import { FileUploader, Popup } from "devextreme-react";
import React from "react";
import RefPopup from "../popup/ref-popup";
import { PopupContentBox } from "../layouts";
import { alertError, baseApiUrl, MessageBool, tokenStorage } from "../../base";
import { UploadedEvent, UploadErrorEvent } from "devextreme/ui/file_uploader";

export interface DeletedBottleImportPopupProps {
    onSaved: () => void;
}

interface DeletedBottleImportPopupState {

}

export default class DeletedBottleImportPopup
    extends React.Component<DeletedBottleImportPopupProps, DeletedBottleImportPopupState> {
    allowedFileExtensions = [".xls", ".xlsx"];
    popupRef = React.createRef<Popup>();

    constructor(props: Readonly<DeletedBottleImportPopupProps>) {
        super(props);

        this.onError = this.onError.bind(this);
        this.onUploaded = this.onUploaded.bind(this);
    }

    show() {
        this.popupRef.current?.instance.show();
    }

    hide() {
        this.popupRef.current?.instance.hide();
    }

    onError(event: UploadErrorEvent) {
        alertError(event.error);
    }

    onUploaded(event: UploadedEvent) {
        const result: MessageBool = JSON.parse(event.request.responseText);

        if (result.succeeded) {
            this.hide();
            this.props.onSaved();
        } else {
            alertError(result.message ?? "");
        }
    }

    nothing() {}

    render() {
        const header = { Authorization: `bearer ${tokenStorage.token}` };
        
        return (
            <RefPopup
                popupRef={this.popupRef}
                title="导入已注销钢瓶"
                width={400}
                height={300}>
                <PopupContentBox 
                    onSave={this.nothing} 
                    onCancel={this.nothing} 
                    hideCancelButton={true} 
                    hideSavebutton={true}>
                    <FileUploader 
                        name="file"
                        uploadMode="useButtons"
                        multiple={false}
                        uploadHeaders={header}
                        uploadUrl={`${baseApiUrl}/api/bottle/import`}
                        allowedFileExtensions={this.allowedFileExtensions}
                        onUploadError={this.onError}
                        onUploaded={this.onUploaded} />
                </PopupContentBox>
            </RefPopup>
        )
    }
}